<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <IconMoreOptionComponent size="small" theme="blue" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <!-- 1. Ver -->
        <el-dropdown-item command="debit-note-view">
          <i class="el-icon-view"></i> Ver
        </el-dropdown-item>

        <!-- 2. Enviar documento -->
        <el-dropdown-item command="debit-note-send">
          <i class="el-icon-s-promotion"></i> Enviar documento
        </el-dropdown-item>

        <!-- Firmar / Re-intentar firma -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="debit-note-signature">
            <i class="el-icon-edit-outline"></i>
            {{ status === "timeout" ? "Re-intentar firma" : "Firmar" }}
          </el-dropdown-item>
        </template>

        <!-- Editar -->
        <template v-if="status === 'draft' || status === 'failed'">
          <el-dropdown-item command="debit-note-edit">
            <i class="el-icon-edit"></i> Editar
          </el-dropdown-item>
        </template>

        <!-- Descargar PDF -->
        <el-dropdown-item command="debit-note-download">
          <i class="el-icon-download"></i> Descargar PDF
        </el-dropdown-item>

        <!-- Anular -->
        <template v-if="status === 'success'">
          <el-dropdown-item command="debit-note-nuled">
            <i class="el-icon-circle-close"></i> Anular nota de débito
          </el-dropdown-item>
        </template>

        <!-- Eliminar (siempre al final) -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="debit-note-delete" divided>
            <i class="el-icon-delete"></i> Eliminar
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>

    <SigningConfirmModal
      :visible.sync="sriModalVisible"
      :documentNumber="debitNote ? debitNote.identification_document : ''"
      :clientName="
        debitNote && debitNote.invoice ? debitNote.invoice.client.name : ''
      "
      :amount="debitNote ? debitNote.total : 0"
      @confirm="sendSRI"
    />

    <el-dialog
      width="80%"
      title=""
      :visible.sync="nuledModalVisible"
      append-to-body
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea anular la nota de débito?
        </h4>
        <p class="text-color-primary">
          Para completar el proceso de anulación debe ser anulada en el
          <LinkSRI />
        </p>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="nuledModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Anular" @onSaveClick="onNuled" />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="200"
      title=""
      :visible.sync="deleteModalVisible"
      append-to-body
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea eliminar la nota de débito?
        </h4>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="deleteModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Eliminar" @onSaveClick="onDelete" />
        </div>
      </div>
    </el-dialog>

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="visibleDocumentSend = false"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="toMails"
      :toPhone="toPhone"
      :clientId="
        debitNote && debitNote.invoice && debitNote.invoice.client
          ? debitNote.invoice.client.id
          : null
      "
      :recipientName="
        debitNote && debitNote.invoice && debitNote.invoice.client
          ? debitNote.invoice.client.name
          : ''
      "
      :messageableType="'debit-note'"
      :messageableId="id"
      :moduleType="'debit-note'"
      :draftKey="'draft-debitnote-' + id"
    />
  </div>
</template>

<style lang="scss" scoped>
.img-sm {
  width: 0.8rem !important;
}
</style>

<script>
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import debitNoteService from "../services/debitNoteService";
import IconMoreOptionComponent from "@/components/General/IconMoreOption";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import LinkSRI from "@/components/General/LinkSRI";
import SigningConfirmModal from "@/components/General/SigningConfirmModal";
import { signingEventBus } from "@/services/signingEventBus";
import {
  icoNotifyDanger,
  iconEdit,
  iconDelete,
  iconNuled,
  iconSend,
  iconDownload,
  icoSignature,
  icoPreview
} from "@/services/resources";
import { downloadFile } from "@/assets/utils/files";

export default {
  name: "DebitNoteOptionsByStatus",
  props: ["status", "id"],
  data() {
    return {
      icoNotifyDanger,
      iconEdit,
      iconDelete,
      iconNuled,
      iconSend,
      iconDownload,
      icoSignature,
      icoPreview,
      sriModalVisible: false,
      nuledModalVisible: false,
      deleteModalVisible: false,
      visibleDocumentSend: false,
      debitNote: null,
      toMails: [],
      toPhone: ""
    };
  },
  methods: {
    async getDebitNote() {
      try {
        let response = await debitNoteService.getDebitNoteId(this.id);
        if (response) this.debitNote = response.data.data;
      } catch (e) {
        return false;
      }
    },
    async handleCommand(command) {
      if (!this.debitNote) {
        await this.getDebitNote();
        await this.$nextTick();
      }
      switch (command) {
        case "debit-note-view":
          this.$emit("goPage", "sales.debitNote.view", { id: this.id });
          break;
        case "debit-note-edit":
          this.$emit("goPage", "sales.debitNote.edit", { id: this.id });
          break;
        case "debit-note-signature":
          this.sriModalVisible = true;
          break;
        case "debit-note-nuled":
          this.nuledModalVisible = true;
          break;
        case "debit-note-delete":
          this.deleteModalVisible = true;
          break;
        case "debit-note-send":
          this.openSendDrawer();
          break;
        case "debit-note-download":
          this.download();
          break;
      }
    },
    async sendSRI() {
      const docId = this.debitNote.id;
      const clientName = this.debitNote.invoice
        ? this.debitNote.invoice.client.name
        : "";
      const documentNumber = this.debitNote.identification_document || "";

      this.sriModalVisible = false;
      signingEventBus.$emit("signing:start", {
        id: docId,
        clientName,
        documentNumber
      });
      this.$emit("onSigningStart", docId);

      try {
        let response = await debitNoteService.sendDebitNoteSRI({
          user_business_debit_note_id: docId
        });
        const { success, message, data } = response.data;
        if (success) {
          signingEventBus.$emit("signing:done", {
            id: docId,
            clientName,
            documentNumber
          });
          this.debitNote = data;
          this.$emit("onSigningDone", { id: docId, data });
        } else {
          signingEventBus.$emit("signing:error", {
            id: docId,
            message: message || "Error al firmar"
          });
          this.$emit("onSigningError", docId);
        }
      } catch (error) {
        signingEventBus.$emit("signing:error", {
          id: docId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al firmar"
        });
        this.$emit("onSigningError", docId);
      }
    },
    async onNuled() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const docId = this.debitNote.id;
        let response = await debitNoteService
          .updateDebitNoteStatusNuled({ user_business_debit_note_id: docId })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.nuledModalVisible = false;
          });
        const { success, message, data } = response.data;
        if (success) {
          this.debitNote = data;
          this.$notifications.success({ message });
          this.$emit("onSigningDone", { id: docId, data });
        }
      } catch (e) {
        return false;
      }
    },
    async onDelete() {
      try {
        const docId = this.debitNote.id;
        let response = await debitNoteService
          .deleteDebitNoteId(docId)
          .finally(() => {
            this.deleteModalVisible = false;
          });
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({ message });
          this.$emit("onDocDeleted", docId);
        }
      } catch (e) {
        return false;
      }
    },
    async download() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { identification_document, id } = this.debitNote;
        let response = await debitNoteService
          .debitNoteDownload({ id })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        if (response.data)
          downloadFile(
            response.data,
            `NotaDebito - #${identification_document}`
          );
      } catch (e) {
        return false;
      }
    },
    openSendDrawer() {
      const client = this.debitNote?.invoice?.client;
      this.toMails = client && client.email ? [client.email] : [];
      this.toPhone = client && client.phone ? String(client.phone).trim() : "";
      this.visibleDocumentSend = true;
    },
    async onDocumentSend({ data }) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        data.append("debit_note_id", this.debitNote.id);
        let response = await debitNoteService
          .sendDebitNoteEmail({ data })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        const { success, message } = response.data;
        if (success) {
          this.visibleDocumentSend = false;
          this.$notifications.success({ message });
        }
      } catch (e) {
        return false;
      }
    }
  },
  components: {
    IconMoreOptionComponent,
    ButtonPrimaryComponent,
    WrapperSendDocumentDrawer,
    LinkSRI,
    SigningConfirmModal
  }
};
</script>
